import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { Observable, Subscription } from 'rxjs';
import { PageState } from 'src/app/core/models/page-state/page-state.model';
import { HydrationService } from 'src/app/core/services/login/hydration.service';
import { LoginService } from 'src/app/core/services/login/login.service';
import { PageStateService } from 'src/app/core/services/onboarding/page-state.service';
import * as HydrationStatusActions from 'src/app/core/store/common/actions/hydration-status.action';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import {
  HydrationRoles,
  HydrationSources,
  IHydrationStatusStore,
} from 'src/app/core/store/common/interfaces/hydration-status-store.interface';
import { selectAllHydrationStatus } from 'src/app/core/store/common/reducers/hydration-status.selector';
import { selectAllEnrollment } from 'src/app/core/store/onboarding/reducers+selectors/enrollment.selector';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { reloadApp } from 'src/app/core/ui-helpers/functions/redirect/reload-app';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pre-dashboard',
  templateUrl: './pre-dashboard.component.html',
  styleUrls: ['./pre-dashboard.component.scss'],
})
export class PreDashboardComponent implements OnInit, OnDestroy {
  nextState: PageState;
  homeState: PageState;
  preQualified: PageState;
  stateId: string;
  showLogoutContainer = false;
  subscriptions: Subscription[] = [];

  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'large',
  };
  properties$: Observable<any>;
  constructor(
    private hs: HydrationService,
    private store: Store<IAppState>,
    private ps: PageStateService,
    private router: Router,
    private route: ActivatedRoute,
    private ls: LoginService
  ) {}

  async ngOnInit(): Promise<void> {
    setTimeout(() => {
      this.showLogoutContainer = true;
    }, 20000);

    const hydrationStatus$ = this.store.select(selectAllHydrationStatus);
    let shouldHydrate = true;
    this.subscriptions.push(
      hydrationStatus$.subscribe((props: IHydrationStatusStore) => {
        console.log(props);
        shouldHydrate =
          props.hydrationSource !== HydrationSources.login &&
          props.hydrationSource !== HydrationSources.loginRememberMe &&
          props.hydrationSource !== HydrationSources.legacyUpgrade;
      })
    );
    if (shouldHydrate) {
      await this.hs.HydrateOnboardingStore(
        HydrationRoles.onboardingProspectOrOnboardingClient,
        HydrationSources.predashboard
      );
    } else {
      this.store.dispatch(
        HydrationStatusActions.HydrationSourceAction({
          hydrationSource: HydrationSources.empty,
        })
      );
    }

    this.properties$ = this.store.select(selectAllEnrollment);
    this.subscriptions.push(
      this.properties$.subscribe(async (props) => {
        if (
          !props.dashboardStateId ||
          props.enrollmentId === '00000000-0000-0000-0000-000000000000'
        ) {
          this.showLogoutContainer = true;
          return false;
        }

        // Check we are requesting for additional information from client
        if (props.hasClientAdditionalInfoRequest) {
          const state =
            await this.ps.getPageState_ClientAdditionalInfoRequestDashboard();
          this.router.navigate([state.pageUrl], {
            queryParams: { stateId: state.id },
          });
          return true;
        }

        this.stateId = props.dashboardStateId;
        const state = await this.ps.loadPageStatesById(this.stateId);
        if (state != null) {
          this.router.navigate([state.pageUrl], {
            queryParams: { stateId: this.stateId },
          });
        } else {
          this.showLogoutContainer = true;
        }
        // TODO: IMPLEMENT RETRY
        return true;
      })
    );
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async logout() {
    this.subscriptions.push(
      this.ls.logout().subscribe((res: any) => {
        if (res === true) {
          reloadApp(environment);
        }
      })
    );
  }
}
